import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=45e238a8&scoped=true&"
import script from "./wxpay.vue?vue&type=script&lang=js&"
export * from "./wxpay.vue?vue&type=script&lang=js&"
import style0 from "./wxpay.vue?vue&type=style&index=0&id=45e238a8&scoped=true&lang=css&"
import style1 from "./wxpay.vue?vue&type=style&index=1&id=45e238a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e238a8",
  null
  
)

export default component.exports